import { render } from "./InsuranceDocuments.vue?vue&type=template&id=4ec9bd42"
import script from "./InsuranceDocuments.vue?vue&type=script&lang=js"
export * from "./InsuranceDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__